import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Compass, ArrowRight, Wrench, Search, Palette, Users, Briefcase, ClipboardList } from 'lucide-react';
import ScrollReveal from '@/components/animations/ScrollReveal';

const personalityIcons = [
  { icon: Wrench, label: { en: 'Doers', es: 'Hacedores' } },
  { icon: Search, label: { en: 'Thinkers', es: 'Pensadores' } },
  { icon: Palette, label: { en: 'Creators', es: 'Creadores' } },
  { icon: Users, label: { en: 'Helpers', es: 'Ayudadores' } },
  { icon: Briefcase, label: { en: 'Leaders', es: 'Líderes' } },
  { icon: ClipboardList, label: { en: 'Organizers', es: 'Organizadores' } },
];

const QuizCTASection = () => {
  const { t, language } = useLanguage();

  return (
    <section className="min-h-screen py-24 md:py-32 lg:py-40 relative z-20 overflow-hidden flex items-center">
      {/* Sunset gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-sunset-600 via-sunset-500 to-sun-300" />
      
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-sand-50/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-forest-700/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-md lg:px-lg relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal>
            <div className="w-20 h-20 mx-auto mb-lg rounded-full bg-sand-50/20 flex items-center justify-center backdrop-blur-sm">
              <Compass className="h-10 w-10 text-sand-50" />
            </div>
          </ScrollReveal>
          <ScrollReveal delay={80}>
            <h2 className="text-h2 md:text-[48px] font-extrabold text-sand-50 mb-md">
              {t('quizCta.title')}
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={160}>
            <p className="text-body md:text-h3 text-sand-50/90 mb-lg max-prose mx-auto">
              {t('quizCta.subtitle')}
            </p>
          </ScrollReveal>
          
          {/* Personality Types Preview */}
          <ScrollReveal delay={200}>
            <div className="flex flex-wrap justify-center gap-3 mb-xl">
              {personalityIcons.map((item, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-2 px-4 py-2 bg-sand-50/15 backdrop-blur-sm rounded-full border border-sand-50/20"
                >
                  <item.icon className="h-4 w-4 text-sand-50" />
                  <span className="text-sm font-medium text-sand-50">{item.label[language]}</span>
                </div>
              ))}
            </div>
          </ScrollReveal>

          <ScrollReveal delay={280}>
            <Button 
              asChild 
              size="lg" 
              className="bg-sand-50 text-sunset-600 hover:bg-sand-100 hover:text-sunset-700 shadow-lift text-body font-bold"
            >
              <Link to="/quiz" className="group">
                {t('quizCta.button')}
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default QuizCTASection;
